<template>
  <v-card-text>
    <DescriptionList v-if="person">
      <DescriptionListItem
        term="Latest Card"
        :description="person.activeCardNum ?? '--'"
      />
      <DescriptionListItem
        term="Email"
        :description="person.email ?? '--'"
      />
      <DescriptionListItem
        term="Current Membership"
        :description="formatMembershipLabel(person) ?? '--'"
      />
      <DescriptionListItem term="Date of Birth" :description="personDob" />
    </DescriptionList>
  </v-card-text>
</template>

<script lang="ts" setup>
import { useUtility } from "@/composables/useUtility";
import { useDate } from "vuetify";
import type { PersonDTOBase } from "../../../cbi-generator/generated/dto/PersonDTOBase";

const date = useDate();
const { calculateAge, formatMembershipLabel } = useUtility();

const props = defineProps<{
  person: Pick<
    PersonDTOBase,
    | "email"
    | "dob"
    | "activeCardNum"
    | "activeMembershipTypeName"
    | "activeMembershipExpiration"
  >;
}>();

const personDob = computed(() => {
  if (props.person?.dob) {
    return `${date.format(new Date(props.person.dob), "keyboardDate")} (${calculateAge(
      new Date(props.person.dob),
    )})`;
  }
  return "--";
});
</script>